// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"384":"6679add5","915":"a48c1cc5"}[chunkId] + ".css";
};